import type { ReactNode } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export type SectionHeadingProps = {
  title?: ReactNode;
  subtitle?: ReactNode;
};

// The single source of truth for section title + subtitle styling. Used by
// `SectionShell` (lease-info / applicants) and by consumer chrome that renders
// its own header in a slot (screening / coverage), so every section's heading
// looks identical. The subtitle is a `div` (not the default `p`) so it can carry
// block content like a help link or multi-line copy.
export function SectionHeading({ title, subtitle }: SectionHeadingProps) {
  const theme = useTheme();
  if (!title && !subtitle) {
    return null;
  }
  return (
    <Box>
      {title ? (
        <Typography
          variant="h6"
          component="h2"
          sx={{
            color: theme.palette.neutralGrey[950],
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: '28px',
            mb: subtitle ? 1 : 0,
          }}
        >
          {title}
        </Typography>
      ) : null}
      {subtitle ? (
        <Typography
          variant="body2"
          component="div"
          sx={{
            fontWeight: 350,
            letterSpacing: 0,
            fontSize: '16px',
            [theme.breakpoints.down('md')]: { fontSize: '14px', lineHeight: '22px' },
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
